const { Type } = require('@sinclair/typebox');
const { merge } = require('lodash');
const Blockly = require('blockly');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');

const TOOLTIP =
    'Allows accessing data in a nested property, either a nested object, or a nested list filtered down to a specific list entry.';

function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    blocklyBlock.setTooltip(TOOLTIP);
    //set inputs to be arranged horizontally (this is the default)
    //Meaning each (dummy)input continues on the top line followed by  the access modifiers
    blocklyBlock.setInputsInline(false);
    line1OfInputs.appendField('  Property Name:').appendField(new Blockly.FieldTextInput('title'), 'propertyName');

    //Statement inputs ALWAYS go on their own line.
    blocklyBlock
        .appendStatementInput('NestedObjectElements')
        .setCheck(['formElement'])
        .appendField('Nested Form Elements:');

    // line 3, just text....
    blocklyBlock
        .appendDummyInput()
        .setAlign(Blockly.ALIGN_LEFT)
        .appendField('In case of an nested list, select the first entry');

    //Statement inputs ALWAYS go on their own line. (line 4)
    blocklyBlock
        .appendStatementInput('filters')
        .setCheck(['filter'])
        .appendField('(Optionally) Which matches all of these filters:');
}

function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties([
        'propertyName',
        {
            key: 'sequence',
            // Song and dance to figure out the sequence based on order in the workspace.
            handler: () => {
                const parent = blocklyBlock.getSurroundParent();
                const parentChildren = parent.getDescendants(false);
                return parentChildren.findIndex(value => value.id === blocklyBlock.id) - 1; // subtract 1 because includes parent with getDescendants
            }
        }
    ]);
    //nested blocks in the statements are added automatically by blockly
    return code;
}

/** Builds the TypeBox schema fragment for the NestedObject form element. */
function asDataDictionary(hNode, context) {
    const { id, title, propertyName } = hNode;
    //This block tells us nothing about namespaces/relations, but maybe the children do?
    let [subDataDictionary = {}, _partialTypeDefinition = {}] = hNode.children?.reduce(
        ([sdd, ptd], child) => {
            const [_subDataDictionary = {}, _partialTypeDefinition = {}] = context.extractFromChild(child, context);
            return [
                merge(sdd, _subDataDictionary),
                moduleRegistration.mergePartialTypeDefinitions(ptd, _partialTypeDefinition, context)
            ];
        },
        [{}, {}]
    ) ?? [{}, {}];

    // NestedObject doesn't have a required parameter, so pass undefined to get default behavior
    const { isOptional, schemaOptions } = moduleRegistration.resolveFieldFlags(undefined, context);

    const isArray = (hNode.children || []).some(c => c.hNodeTypeGroup === 'filter');

    const propertySchema = isArray
        ? Type.Array(
              Type.Object(_partialTypeDefinition, {
                  title: 'Item',
                  'x-dataType': 'object',
                  additionalProperties: true
              }),
              {
                  'x-id': id,
                  'x-dataType': 'array',
                  'x-propertyName': propertyName,
                  title: title,
                  ...schemaOptions
              }
          )
        : Type.Object(_partialTypeDefinition, {
              'x-id': id,
              'x-dataType': 'object',
              'x-propertyName': propertyName,
              title: title,
              ...schemaOptions,
              additionalProperties: true
          });

    const wrappedSchema = isOptional ? Type.Optional(propertySchema) : propertySchema;

    const partialTypeDefinition = {
        [propertyName]: wrappedSchema
    };

    return [subDataDictionary, partialTypeDefinition];
}

module.exports = { addBlockSpecificFields, convertCustomFieldsToCode, asDataDictionary };
